import { AAGUID } from '@interticket/core';
import { Address } from '../address/address.model';
import { IVenueListItem } from '@core/interfaces/venue/venue-list-item.interface';

export class VenueListItem implements IVenueListItem {

  readonly id: AAGUID;
  readonly partnerId: AAGUID;
  readonly name: string;
  readonly address: Address;

  constructor(iVenue: IVenueListItem) {
    this.id = iVenue.id;
    this.partnerId = iVenue.partnerId;
    this.name = iVenue.name;
    this.address = new Address(iVenue.address);
  }

}
